import { module } from 'angular';
import templateBuilderQtyDisplay from './builder/display.html';
import templateBuilderQtyData from './builder/data.html';
import templateBuilderQtyValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/qty/display.html', templateBuilderQtyDisplay);
	$templateCache.put('kform/components/qty/data.html', templateBuilderQtyData);
	$templateCache.put('kform/components/qty/validate.html', templateBuilderQtyValidate);
});
